import { SegmentBlueprint } from '../types';

export const mockSegments: Record<string, SegmentBlueprint> = {
  'imobiliarias': {
    id: 'seg_imobiliaria',
    name: 'Imobiliárias e Corretores',
    slug: 'imobiliarias',
    tagline: 'Estrutura digital completa para captação, apresentação e venda de imóveis.',
    description: 'Transforme a presença da sua imobiliária em um ecossistema de autoridade com busca avançada, agendamento de visitas, captação de proprietários e CRM imobiliário.',
    icon_name: 'Home',
    primary_color: '#059669',
    bg_color: '#064E3B',
    surface_color: '#022C22',
    accent_color: '#34D399',
    text_color: '#ECFDF5',
    journey_steps: [
      { title: 'Anúncio de Imóvel ou Busca no Google', description: 'O comprador ou inquilino encontra o imóvel por filtros locais.', icon: 'Search' },
      { title: 'Landing Page de Alta Conversão', description: 'Visualização de ficha técnica, fotos em alta resolução e agendamento.', icon: 'Layout' },
      { title: 'Agendamento de Visita no WhatsApp', description: 'Conversão direta com o corretor responsável pelo imóvel.', icon: 'MessageSquare' },
      { title: 'Gestão no CRM Imobiliário', description: 'Acompanhamento da proposta, documentação e contratos.', icon: 'Users' }
    ],
    diagnostic_questions: [
      'Como seus clientes encontram seus imóveis hoje (Google, Portais ou Instagram)?',
      'Como sua equipe gerencia o histórico de preferências de quem busca comprar ou alugar?',
      'Os proprietários possuem um canal fácil para cadastrar novos imóveis?'
    ],
    features: {
      site: [
        'Busca avançada com filtros por tipo, bairro, faixa de preço e finalidade',
        'Ficha completa do imóvel com galeria HD, vídeo e ficha técnica',
        'Página de captação "Quero Vender/Alugar meu Imóvel"',
        'Calculadora de simulação de financiamento (informativa)'
      ],
      biolink: [
        'Microportal mobile para perfil do Instagram dos corretores',
        'Atalhos rápidos para lançamentos, busca de imóveis e atendimento',
        'Cartão de visita digital para a equipe de vendas'
      ],
      app: [
        'App PWA para clientes favoritarem imóveis e acompanharem visitas',
        'Notificações de novos imóveis no perfil desejado',
        'Área do proprietário para acompanhar propostas'
      ],
      system: [
        'CRM Imobiliário com pipeline de negociações por corretor',
        'Gestão de estoque de imóveis e proprietários',
        'Relatórios de visualizações e leads por imóvel'
      ],
      marketing: [
        'Campanha no Google Search para buscas como "apartamento à venda em SMO"',
        'Anúncios em carrossel no Meta para imóveis em destaque',
        'Produção de conteúdo em vídeo (tours virtuais)'
      ]
    },
    pricing_plans: [
      {
        name: 'Presença Imobiliária Essencial',
        setup_price: 2500,
        monthly_price: 350,
        features: [
          'Portal Imobiliário Responsivo com Filtros',
          'Biolink Mobile para Corretores',
          'Integração com WhatsApp',
          'Suporte e Hospedagem Inclusos'
        ]
      },
      {
        name: 'Ecossistema Imobiliário 360º',
        setup_price: 4800,
        monthly_price: 1500,
        ad_budget: 'Verba de mídia sugerida: R$ 1.000/mês',
        features: [
          'Portal Imobiliário Completo com Filtros em Mapa',
          'CRM de Atendimento & Gestão de Leads',
          'Gestão de Tráfego Pago (Google & Meta)',
          'App PWA para Clientes e Proprietários'
        ]
      }
    ]
  },

  'restaurantes': {
    id: 'seg_restaurante',
    name: 'Restaurantes, Delivery e Pizzarias',
    slug: 'restaurantes',
    tagline: 'Cardápio digital próprio, pedidos diretos e programa de fidelidade.',
    description: 'Elimine altas taxas de intermediários com um cardápio digital próprio, Kanban de pedidos na cozinha, atendimento direto via WhatsApp e clube de cashback.',
    icon_name: 'Utensils',
    primary_color: '#E11D48',
    bg_color: '#4C0519',
    surface_color: '#881337',
    accent_color: '#FB7185',
    text_color: '#FFF1F2',
    journey_steps: [
      { title: 'Divulgação em Redes ou Google Maps', description: 'Cliente acessa o cardápio via QR Code na mesa ou link da bio.', icon: 'QrCode' },
      { title: 'Navegação no Cardápio Digital', description: 'Seleção de adicionais, observações do prato e montagem do pedido.', icon: 'ShoppingBag' },
      { title: 'Envio Direto para Cozinha e WhatsApp', description: 'Pedido cai no painel de preparo e confirmação rápida para o cliente.', icon: 'ChefHat' },
      { title: 'Fidelização & Cashback', description: 'Acúmulo de pontos para o próximo pedido.', icon: 'Award' }
    ],
    diagnostic_questions: [
      'Qual porcentagem dos seus pedidos hoje depende de aplicativos terceirizados com taxas altas?',
      'Como seu restaurante avisa os clientes sobre promoções do dia ou eventos sazonais?',
      'Sua equipe tem facilidade para alterar preços ou pausar itens esgotados no cardápio?'
    ],
    features: {
      site: [
        'Cardápio digital responsivo e ultra-rápido para smartphones',
        'Personalização de adicionais, combos e opções de entrega/retirada',
        'Visualização de galeria de pratos com fotos profissionais',
        'Aviso automático de status do restaurante (Aberto/Fechado)'
      ],
      biolink: [
        'Microportal para Instagram com link direto para o cardápio',
        'Botões de reserva de mesa, localizador no Google Maps e promoções'
      ],
      app: [
        'App Web PWA sem necessidade de download na loja',
        'Clube de Fidelidade com acúmulo de pontos/cashback',
        'Notificações Push com ofertas no horário de almoço ou janta'
      ],
      system: [
        'Painel Kanban de pedidos para a cozinha e expedição',
        'Relatório de itens mais vendidos e ticket médio',
        'Gestão simples de cardápio e preços'
      ],
      marketing: [
        'Anúncios de tráfego local no raio do restaurante',
        'Otimização do Perfil da Empresa no Google (Google Meu Negócio)',
        'Campanhas de retargeting para clientes que não pedem há mais de 15 dias'
      ]
    },
    pricing_plans: [
      {
        name: 'Cardápio Digital Essencial',
        setup_price: 2000,
        monthly_price: 350,
        features: [
          'Cardápio Digital Responsivo sem comissão por pedido',
          'Integração direta com WhatsApp',
          'Biolink Mobile para Instagram',
          'Atualização simples de preços'
        ]
      },
      {
        name: 'Operação Delivery 360º',
        setup_price: 4200,
        monthly_price: 1500,
        ad_budget: 'Verba de mídia sugerida: R$ 800/mês',
        features: [
          'Cardápio Digital + Painel Kanban para Cozinha',
          'App de Fidelidade & Cashback para Clientes',
          'Gestão de Tráfego Pago Local no Meta & Google',
          'Otimização do Perfil no Google Maps'
        ]
      }
    ]
  },

  'contabilidade': {
    id: 'seg_contabilidade',
    name: 'Escritórios de Contabilidade',
    slug: 'contabilidade',
    tagline: 'Autoridade digital, captação de novas empresas e portal do cliente.',
    description: 'Apresente seu escritório com autoridade no Google, estruture um funil para abertura e migração de empresas, e ofereça um portal organizado para envio de guias e documentos.',
    icon_name: 'FileCheck',
    primary_color: '#2563EB',
    bg_color: '#1E3A8A',
    surface_color: '#172554',
    accent_color: '#60A5FA',
    text_color: '#EFF6FF',
    journey_steps: [
      { title: 'Busca por Abertura ou Troca de Contador', description: 'Empresário encontra a contabilidade no Google Search.', icon: 'Search' },
      { title: 'Diagnóstico & Triagem de Perfil', description: 'Formulário rápido para identificar segmento, regime tributário e faturamento.', icon: 'FileText' },
      { title: 'Proposta Comercial Consultiva', description: 'Apresentação transparente dos serviços e honorários.', icon: 'Briefcase' },
      { title: 'Onboarding & Portal do Cliente', description: 'Entrega de documentos e guias mensais de forma segura.', icon: 'Lock' }
    ],
    diagnostic_questions: [
      'Quantas solicitações de orçamento para abertura de empresas seu escritório recebe por mês no Google?',
      'Como seus clientes enviam os documentos e acessam as guias mensais hoje?',
      'O site atual da contabilidade passa a sensação de autoridade e segurança jurídica?'
    ],
    features: {
      site: [
        'Página de autoridade focada em Abertura de Empresa e Troca de Contador',
        'Páginas específicas por nicho de atuação (Médicos, TI, Comércio, Prestadores)',
        'Calculadora informativa de estimativa de honorários',
        'Área institucional apresentando a equipe e a história do escritório'
      ],
      biolink: [
        'Microportal para Instagram focado em atalhos para empresários',
        'Link direto para simulação de impostos ou atendimento de urgência'
      ],
      app: [
        'Portal PWA do Cliente para consulta de guias e certidões no celular',
        'Avisos de vencimento de impostos para evitar multas',
        'Envio de fotos de comprovantes e documentos'
      ],
      system: [
        'Painel de Gestão de Solicitações e Chamados de clientes',
        'Controle de onboarding de novas empresas contratadas',
        'Relatórios de origem de leads e taxa de conversão'
      ],
      marketing: [
        'Campanha no Google Ads focada em termos com alta intenção ("abrir empresa")',
        'Produção de artigos e guias tributários para blog com SEO',
        'Anúncios no LinkedIn e Instagram direcionados a empresários da região'
      ]
    },
    pricing_plans: [
      {
        name: 'Autoridade Digital Essencial',
        setup_price: 2500,
        monthly_price: 350,
        features: [
          'Site Institucional de Alta Autoridade',
          'Formulário de Triagem para Abertura de Empresa',
          'Biolink Profissional',
          'Integração com WhatsApp'
        ]
      },
      {
        name: 'Aceleração Comercial Contábil 360º',
        setup_price: 4900,
        monthly_price: 1500,
        ad_budget: 'Verba de mídia sugerida: R$ 1.200/mês',
        features: [
          'Site Institucional + Páginas por Nicho (Médicos, TI, etc.)',
          'Portal do Cliente para envio de Guias e Documentos',
          'Gestão de Tráfego Pago no Google Ads',
          'CRM de Atendimento & Produção de Conteúdo'
        ]
      }
    ]
  },

  'saloes-estetica': {
    id: 'seg_saloes',
    name: 'Salões de Beleza, Barbearias e Estética',
    slug: 'saloes-estetica',
    tagline: 'Agendamento online por profissional, vitrine visual e retenção de clientes.',
    description: 'Transforme o agendamento do seu salão em uma experiência simples sem filas de espera, com escolha de profissional, lembretes automáticos de retorno e clube de fidelidade.',
    icon_name: 'Scissors',
    primary_color: '#D946EF',
    bg_color: '#701A75',
    surface_color: '#4A044E',
    accent_color: '#F0ABFC',
    text_color: '#FDF4FF',
    journey_steps: [
      { title: 'Acesso via Instagram ou Google', description: 'Cliente clica no biolink do perfil ou busca por salão na região.', icon: 'Instagram' },
      { title: 'Escolha de Serviço & Profissional', description: 'Seleção do procedimento, profissional de preferência e horário livre.', icon: 'Calendar' },
      { title: 'Lembrete Automático por WhatsApp', description: 'Confirmação na véspera para reduzir faltas (no-show).', icon: 'MessageCircle' },
      { title: 'Retorno & Avaliação pós-serviço', description: 'Lembrete de manutenção após o período ideal.', icon: 'Heart' }
    ],
    diagnostic_questions: [
      'Quanto tempo sua recepção gasta respondendo mensagens no WhatsApp apenas para conferir horários disponíveis?',
      'Qual é a sua taxa média de faltas (no-show) por semana?',
      'Seu salão lembra os clientes automaticamente quando chega a hora de retocar a cor ou fazer manutenção?'
    ],
    features: {
      site: [
        'Vitrine visual de serviços, procedimentos e portfólio de resultados',
        'Apresentação da equipe de profissionais com biografia e especialidades',
        'Sistema de agendamento online integrado por profissional',
        'Tabela clara de serviços com tempo estimado de duração'
      ],
      biolink: [
        'Microportal para Instagram com botão em destaque "Agendar Horário"',
        'Galeria de antes e depois autorizada',
        'Localizador do salão e horários de funcionamento'
      ],
      app: [
        'App do Cliente para agendar e reagendar horários em segundos',
        'Histórico de procedimentos realizados e fotos salvas',
        'Clube de Pontos / Fidelidade'
      ],
      system: [
        'Agenda Unificada por profissional/cadeira',
        'Ficha anamnese e registro de preferências do cliente',
        'Controle de comissões da equipe e lembretes automáticos'
      ],
      marketing: [
        'Anúncios no Meta Ads direcionados para o público feminino/masculino local',
        'Campanhas sazonais (Dia das Mães, Festas de Fim de Ano)',
        'Estratégia de incentivo para avaliações 5 estrelas no Google'
      ]
    },
    pricing_plans: [
      {
        name: 'Agendamento Essencial',
        setup_price: 2000,
        monthly_price: 350,
        features: [
          'Site Vitrine com Agendamento Online',
          'Biolink Otimizado para Instagram',
          'Lembretes de Confirmação no WhatsApp',
          'Suporte e Hospedagem Inclusos'
        ]
      },
      {
        name: 'Gestão & Escala Estética 360º',
        setup_price: 4500,
        monthly_price: 1500,
        ad_budget: 'Verba de mídia sugerida: R$ 800/mês',
        features: [
          'Site + Sistema de Agendamento por Profissional',
          'App do Cliente com Clube de Pontos',
          'Gestão de Tráfego Pago no Instagram e Google',
          'Envio Automático de Reativação de Clientes Sumidos'
        ]
      }
    ]
  }
};
